import { combineReducers } from "redux";

import dashboardReducer from "./dashboardReducer";
import filesReducer from "./filesReducer";
import reportsReducer from "./reportsReducer";
import accessControlReducer from "./accessControl";
import saslReducer from "./saslReducer";
import qualityEventsReducer from "./qualityEventsReducer";
import projectsReducer from "./projectReducer";
import forecastScheduleReducer from "./forecastScheduleReducer";
import filtersReducer from './filtersReducer';
import purchaseOrderReducer from "./purchaseOrderReducer";
import rolesAndAccessReducer from "./rolesAndAccessReducer";
import teamMembersReducer from "./teamMemberReducer";
import inventoryStatusReducer from "./inventoryStatusReducer";
import purchaseOrderNewreducer from "./purchaseOrderNewreducer";
import uiStateReducer from "./uiStateReducer";
import notificationsReducer from "./notificationsReducer";
import sapAuditReducer from "./sapAuditReducer";

export default combineReducers({
  dashboard: dashboardReducer,
  reports: reportsReducer,
  files: filesReducer,
  accessControl: accessControlReducer,
  sasl: saslReducer,
  QMS: qualityEventsReducer,
  Projects: projectsReducer,
  forecastSchedule: forecastScheduleReducer,
  filters: filtersReducer,
  purchaseOrder: purchaseOrderReducer,
  rolesAndAccess :rolesAndAccessReducer,
  teamMembers:teamMembersReducer,
  inventoryStatus : inventoryStatusReducer,
  poNew:purchaseOrderNewreducer,
  uiState: uiStateReducer,
  notifications: notificationsReducer,
  sapAudit: sapAuditReducer,
});
